import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58ec1046"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "mau_modal_send_email",
  ref: "modalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "aria-modal": "true",
  "aria-label": "Enviar correo",
  role: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1))
const _hoisted_7 = {
  class: "scroll-y",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "modal-footer flex-center" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("modal.sendEmail.titulo") || "Enviar correo"), 1),
          _hoisted_6
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.asunto,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.asunto) = $event)),
                  placeholder: "Asunto"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 8,
                  modelValue: _ctx.mensaje,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mensaje) = $event)),
                  placeholder: "Mensaje..."
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light me-3",
              "data-bs-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
            }, _toDisplayString(_ctx.$t("dialogs.cancelButton") || "Cancelar"), 1),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-lg btn-primary",
              disabled: _ctx.sending || !_ctx.isFormValid()
            }, [
              (!_ctx.sending)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("dialogs.sendButton") || "Enviar"), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.$t("dialogs.sending") || "Enviando...") + " ", 1),
                    _hoisted_15
                  ]))
            ], 8, _hoisted_12)
          ])
        ], 32)
      ])
    ])
  ], 512))
}